

<template>
  <div class="container">
    <div class="row">
      <div class="col-12 webpage-section-content" style="padding-top: 28px;" v-html="cateringSettings.content.replace(/\n/g, '<br/>')">
      </div>
    </div>
    <div class="row" v-if="cateringSettings.images !== undefined && cateringSettings.images.length > 0">
      <div class="col-6 col-md-4 web-gallery-item-container" v-for="img in cateringSettings.images">
        <div class="web-gallery-item" v-bind:style="{backgroundImage: 'url(' + getThumbnamil(img, '512') + ')'}"/>
      </div>
    </div>
    <template  v-if="form !== false">
      <div class="row booking-form-row text-left">
        <div class="col-12 text-center">
          <span style="font-weight: bold; color: black; font-size: 20px;">Catering Service Inquiry Form</span>
          <br/>Please enter correct contact or email address. Otherwise, we cannot contact you.
        </div>
        <div class="col-12 col-md-4">
          Date *
          <div class="white-input" style="border-radius: 0.25rem;">
            <date-picker style="width: 100%; "
                         :lang="'en'"
                         class="date-picker"
                         input-class="date-picker"
                         v-model="form.requestedDate"
                         typable="false"
                         placeholder="Select Date"
                         valueType="format"></date-picker>
          </div>
        </div>
        <div class="col-12 col-md-4">
          Group Size (Number of people) *
          <select class="form-control" v-model="form.groupSize">
            <option v-for="(i, ii) in 100" :key="'catering-group-size-' + ii" :value="ii">{{ii}}</option>
          </select>
        </div>
        <div class="col-12 col-md-4">
          Location
          <input class="form-control" v-model="form.address"/>
        </div>
      </div>
      <div class="row booking-form-row text-left">
        <div class="col-12 col-md-4">
          Name *
          <input class="form-control" type="text" v-model="form.name" placeholder="Name">
        </div>
        <div class="col-12 col-md-4">
          Mobile Number *
          <input class="form-control" type="text" v-model="form.contact" placeholder="Mobile Number">
        </div>

        <div class="col-12 col-md-6">
          Email *
          <input class="form-control" type="text" v-model="form.email" placeholder="Email">

        </div>
        <div class="col-12">
          Message
          <textarea class="form-control" rows="3" v-model="form.content"/>
        </div>
      </div>
      <div class="row booking-form-row">
        <div class="col-12">
          <button class="btn gray-submit-button" v-bind:class="{'enabled-black': canSubmit(false) === true}" v-on:click="submitInquiry">Send Inquiry</button>
        </div>
      </div>
    </template>
    <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); z-index: 10;" v-if="popup !== false" v-on:click="popup = false">
      <div class="popup-container" @click="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12 popup-title" style="margin-top: 10px;">
              {{popup.title}}
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p v-html="popup.message"></p>
            </div>
          </div>
          <div class="row" style="padding-bottom: 20px;">
<!--            <div class="col-6"  v-if="popup.noBtnTitle.length > 0" v-on:click.stop="clickedOnNo">-->
<!--              <div class="positive-button negative-button">-->
<!--                {{popup.noBtnTitle}}-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-6"  v-if="popup.yesBtnTitle.length > 0" v-on:click.stop="clickedOnYes">-->
<!--              <div class="positive-button">-->
<!--                {{popup.yesBtnTitle}}-->
<!--              </div>-->
<!--            </div>-->
            <div class="col-12">
              <div class="smtm-btn" @click="popup = false">Close</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import EventBus from "../api/event-bus";
import DatePicker from 'vue2-datepicker';
import {submitInquiryForm} from "../api/borium";

export default {
  name:'CateringSerivce',
  props: {
    merchant:{
      type:Object,
      default: function(){return null;}
    },
    cateringSettings: {
      type:Object,
      default: function(){return null;}
    }
  },
  data() {
    return {
      form: false,
      popup: false,
    }
  },
  components: {
    DatePicker
  },
  created() {
    this.setNewForm();
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    dummy: function(){

    },
    getThumbnamil: function(url, size = 300) {
      if(url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus") || url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/webs/")) {
        let words = url.split('.');
        words[words.length-2] += '_' + size + 'x' + size;
        return words.join('.');
      }
      return url;
    },
    setNewForm: function() {
      this.$data.form = {
        name: '',
        email:'',
        contact:'',
        requestDate:'',
        inquiryType:'cateringService',
        subscriptionId:this.merchant.merchantId,
        groupSize:0,
        title:'',
        address:'',
        content:'',
      }
    },
    canSubmit: function(showDialog = true) {
      if(this.$data.form.name === null || this.$data.form.name.length === 0) {
        if(showDialog) this.showDialog("ERROR", "Please enter your name");
        return false;
      }
      if(this.$data.form.email === null || this.$data.form.email.length === 0) {
        if(showDialog) this.showDialog("ERROR", "Please enter your email address");
        return false;
      }
      if(this.$data.form.contact === null || this.$data.form.contact.length === 0) {
        if(showDialog) this.showDialog("ERROR", "Please enter your phone number");
        return false;
      }
      if(this.$data.form.groupSize === 0) {
        if(showDialog) this.showDialog("ERROR", "Please enter the group size for the catering service");
        return false;
      }

      return true;
    },
    submitInquiry: function() {
      if(this.canSubmit() === false) {
        return;
      }

      let self = this;
      submitInquiryForm(this.$data.form)
        .then(function(data) {
          if(data.success === true) {
            self.setNewForm();
            self.showDialog("Success!", "Your inquiry has been sent and you will be contacted shortly. Thank you");
          } else {
            self.showDialog("Failed", "Your inquiry has been sent and you will be contacted shortly. Thank you");
          }
        })
        .catch(function(err) {
          console.log(err);
          self.showDialog("ERROR", "Sorry. Error occurred. Please try again or call restaurant.");
        })

    },
    showDialog: function(message, title = '') {
      this.$data.popup = {
        title:title,
        text:message
      }
      // this.$modal.show('dialog', params);
    }
  }
}

</script>
<style scoped>
.booking-form-row input, select, select:disabled {
  height: 62px;
  line-height: 64px;
  border: none;
  background-color: white;

}
select option:first-of-type {
  color: red;
}
.booking-form-row textarea {
  border: none;
}
.white-input {
  height: 62px;
  background-color: #FFF;
  padding:12px 0;
}
.date-picker {
  border: unset;
  background-color: white;
  padding-left: 10px;
}

.gray-submit-button {
  background: #ABABAB;
  color: white;
  border-radius: unset;
  padding: 18px 84px;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.1em;
}
.enabled-black {
  background-color: black;
}
.popup-title {
  font-size: 20px;
  font-weight: bold;
}
.smtm-btn {
  background: #E7344C;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 30px;
  cursor: pointer;
}
.webpage-section-content p {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CateringService.vue